import * as React from 'react';
import { Icon } from '../';

const IconAvatar = ({ colour, icon, iconColour = '#28313c', size = '64' }) => (
  <span
    className={`avatar image is-${size}x${size}`}
    style={{ backgroundColor: colour, color: iconColour }}
  >
    <Icon icon={icon} size={size === '64' ? 'large' : 'medium'} />
  </span>
);

export default IconAvatar;
